// Bileli · shared/lib — the Bileli-surface THEME (dark default / warm-cream light), persisted per browser.
// Both token sets live in shared/styles/bileli-tokens.scss keyed by [data-bileli-theme]; every element that
// carries the .BileliWorkspace class (the workspace root AND portalled panels like BPopover) must stamp the
// attribute from this store, or portals would stay dark in light mode.

import { createStore } from './zustandTeact';

export type BileliTheme = 'dark' | 'light';

const THEME_KEY = 'bileli:theme';

function readTheme(): BileliTheme {
  try {
    return localStorage.getItem(THEME_KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export const bileliThemeStore = createStore<{ theme: BileliTheme }>(() => ({ theme: readTheme() }));

export function setBileliTheme(theme: BileliTheme): void {
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
    // storage unavailable — the choice just won't survive a reload
  }
  bileliThemeStore.setState({ theme }, true);
}
